import { TooltipModel } from '@notino/react-styleguide';

import { css } from '@linaria/core';

export const TOOLTIP_OFFSET_PX = 16;
const offset = `${TOOLTIP_OFFSET_PX}px`;

export const TOOLTIP_SIDE_OFFSET_CSS_VAR = '--tooltip-side-offset';

export const getTooltipPositionClass = ({
  position,
}: {
  position: TooltipModel.Position;
}) => {
  switch (position) {
    case TooltipModel.Position.topAutomatic:
    case TooltipModel.Position.topCenter:
      return css`
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
      `;
    case TooltipModel.Position.topLeft:
      return css`
        bottom: 100%;
        left: 50%;
        transform: translateX(calc(-1 * var(${TOOLTIP_SIDE_OFFSET_CSS_VAR})));
      `;
    case TooltipModel.Position.topRight:
      return css`
        bottom: 100%;
        right: 50%;
        transform: translateX(var(${TOOLTIP_SIDE_OFFSET_CSS_VAR}));
      `;
    case TooltipModel.Position.bottomAutomatic:
    case TooltipModel.Position.bottomCenter:
      return css`
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      `;
    case TooltipModel.Position.bottomLeft:
      return css`
        top: 100%;
        left: 50%;
        transform: translateX(calc(-1 * var(${TOOLTIP_SIDE_OFFSET_CSS_VAR})));
      `;
    case TooltipModel.Position.bottomRight:
      return css`
        top: 100%;
        right: 50%;
        transform: translateX(var(${TOOLTIP_SIDE_OFFSET_CSS_VAR}));
      `;
    case TooltipModel.Position.leftCenter:
      return css`
        top: 50%;
        transform: translateY(-50%);
        right: 100%;
      `;
    case TooltipModel.Position.leftTop:
      return css`
        top: 50%;
        transform: translateY(-20px);
        right: 100%;
      `;
    case TooltipModel.Position.leftBottom:
      return css`
        bottom: 50%;
        transform: translateY(20px);
        right: 100%;
      `;
    case TooltipModel.Position.rightCenter:
      return css`
        top: 50%;
        transform: translateY(-50%);
        left: 100%;
      `;
    case TooltipModel.Position.rightTop:
      return css`
        top: 50%;
        transform: translateY(-20px);
        left: 100%;
      `;
    case TooltipModel.Position.rightBottom:
      return css`
        bottom: 50%;
        transform: translateY(20px);
        left: 100%;
      `;
    default:
      throw new Error('Invalid position');
  }
};

const interactiveOffsetStyles = css`
  &.top-position {
    padding-bottom: ${offset};
  }
  &.bottom-position {
    padding-top: ${offset};
  }
  &.left-position {
    padding-right: ${offset};
  }
  &.right-position {
    padding-left: ${offset};
  }
`;

const nonInteractiveOffsetStyles = css`
  &.top-position {
    margin-bottom: ${offset};
  }
  &.bottom-position {
    margin-top: ${offset};
  }
  &.left-position {
    margin-right: ${offset};
  }
  &.right-position {
    margin-left: ${offset};
  }
`;

export const getTooltipOffsetClass = ({
  interactive,
}: {
  interactive: boolean;
}) => {
  return interactive ? interactiveOffsetStyles : nonInteractiveOffsetStyles;
};

export const getPositionClass = (position: TooltipModel.Position) => {
  if (
    position === TooltipModel.Position.topAutomatic ||
    position === TooltipModel.Position.topCenter ||
    position === TooltipModel.Position.topLeft ||
    position === TooltipModel.Position.topRight
  ) {
    return 'top-position';
  }
  if (
    position === TooltipModel.Position.bottomAutomatic ||
    position === TooltipModel.Position.bottomCenter ||
    position === TooltipModel.Position.bottomLeft ||
    position === TooltipModel.Position.bottomRight
  ) {
    return 'bottom-position';
  }
  if (
    position === TooltipModel.Position.leftCenter ||
    position === TooltipModel.Position.leftTop ||
    position === TooltipModel.Position.leftBottom
  ) {
    return 'left-position';
  }
  if (
    position === TooltipModel.Position.rightCenter ||
    position === TooltipModel.Position.rightTop ||
    position === TooltipModel.Position.rightBottom
  ) {
    return 'right-position';
  }
  throw new Error('Invalid position');
};
